import { EntityType } from '@frontend/common';
import { Spinner } from '@frontend/components/common';
import { Form } from '@frontend/components/forms';
import { DeceasedClient } from '@frontend/deceased/api';
import { IDeceased, UpdateDeceased } from '@frontend/deceased/types';
import { CommonMessage } from '@frontend/lang';
import { WorkflowType } from '@frontend/workflow/types';
import { useMemo } from 'react';

import { useDeceasedUpdate } from './deceased-update.controller';

const ID = 'deceased-update';
export const DeceasedUpdate = () => {
    const viewProps = useDeceasedUpdate();

    const fieldProps = useMemo(
        () =>
            new Map<keyof UpdateDeceased, object>([
                [
                    'workflow_id',
                    {
                        queryParams: { account_id: viewProps.deceased?.account_id, type: WorkflowType.DECEASED },
                        isClearable: true
                    }
                ],
                ['date_of_death', { dateTime: false }]
            ]),
        [viewProps.deceased?.account_id]
    );

    return (
        <div id={ID}>
            {viewProps.deceased === null ? (
                <Spinner />
            ) : (
                <Form<IDeceased, UpdateDeceased>
                    id={ID}
                    useStaticId
                    object={viewProps.deceased}
                    type={EntityType.DECEASED}
                    dispatch={viewProps.dispatch}
                    value={viewProps.deceased}
                    show={['name', 'workflow_id', 'elys_number', 'date_of_death', 'cremation_timestamp', 'spot_id']}
                    keyOverwrite={
                        new Map([
                            ['elys_number', CommonMessage.OBJECTS.DECEASED.ELYS_NUMBER],
                            ['spot_id', CommonMessage.OBJECTS.SPOT.DEFAULT]
                        ])
                    }
                    fieldProps={fieldProps}
                    onCancel={viewProps.onCancel}
                    onSubmit={(v) => DeceasedClient.patchDeceased(viewProps.deceased!.account_id, viewProps.deceased!.id, v)}
                    onSubmitSuccess={viewProps.onSubmitSuccess}
                />
            )}
        </div>
    );
};
